import * as React from 'react';
import { FC } from 'react';
import useCampaigns from 'app/CasinoGames/useJackpotAggregatorCampaigns';
import Modal from '../CasinoGameModal';
import Launcher from '../CasinoGameLauncher';
import SectionCarousel from './SectionCarousel';
import SectionGrid from './SectionGrid';
import useGameStarter from './useGameStarter';
import { CasinoGamesProps, PaginatedGames } from './types';
import useGames from './useGames';
import { SectionProps } from './section';
import { LocalesContext } from './locales';

const CasinoGames: FC<CasinoGamesProps> = (props) => {
  const gameStarter = useGameStarter();
  const { gameSections, searchParams } = useGames(props);
  const { mobileVisitor, playerPresent, searchPaths } = props.common;
  const jackpotAggregatorCampaigns = useCampaigns(props.common.jackpotAggregatorCampaigns);

  const sectionNames = Object.keys(gameSections);

  const section = (paginatedGames: PaginatedGames, labelId: SectionProps['labelId']) => {
    const inGrid = searchParams || props.mode !== 'carousel';
    const Section = inGrid ? SectionGrid : SectionCarousel;
    if (!paginatedGames) return null;
    return (
      <div className="casino-games" data-items={paginatedGames.data.length}>
        <Section
          paginatedGames={paginatedGames}
          common={props.common}
          gameStarter={gameStarter}
          labelId={labelId}
          key={paginatedGames.data.length > 0 ? paginatedGames.data[0].id : 0}
        />
      </div>
    );
  };

  const gamesInSection = (sectionName: string) => {
    const labelId = `section-${sectionName.replace(/\s/, '-')}`;
    return (
      <div>
        <div className="allbadged">
          <a href={searchPaths[sectionName]}>{props.locales[`all_${sectionName}`]}</a>
        </div>
        <h2 id={labelId}>{props.locales[sectionName]}</h2>
        {section(gameSections[sectionName], labelId)}
      </div>
    );
  };

  const gameModal = () => (
    <Modal game={gameStarter.game} onClose={gameStarter.close} jackpotAggregatorCampaigns={jackpotAggregatorCampaigns}>
      <Launcher
        game={gameStarter.game}
        mobileVisitor={mobileVisitor}
        playerPresent={playerPresent}
        playMode={gameStarter.playMode}
        jackpotAggregatorCampaigns={jackpotAggregatorCampaigns}
      />
    </Modal>
  );

  const renderList = () => section(gameSections[sectionNames[0]], 'section-games-list');

  const renderSections = () => (
    <div>
      {sectionNames.map((sectionName) => (
        <div key={sectionName}>{gameSections[sectionName].data.length ? gamesInSection(sectionName) : null}</div>
      ))}
    </div>
  );

  if (!sectionNames.length) return null;

  return (
    <div>
      <LocalesContext.Provider value={props.locales}>
        {sectionNames.length > 1 ? renderSections() : renderList()}
        {gameStarter.opened ? gameModal() : null}
      </LocalesContext.Provider>
    </div>
  );
};

export default CasinoGames;
